export default {
  easypaisa__enter_number: 'Enter your Easypaisa number',
  easypaisa__enter_number_jazzcash: 'Enter your JazzCash number',
  easypaisa__placeholder: 'e.g. 03XXXXXXXXX',
  easypaisa__hint: '11 digits, starts with 03',
  easypaisa__validation_error: 'Enter a Valid Easypaisa Wallet No.\n(11 digits, starts with 03)',
  easypaisa__session_timed_out: 'Session timed out',
  easypaisa__close: 'CLOSE',
  easypaisa__confirm: 'CONFIRM',
  easypaisa__try_again: 'TRY AGAIN',

  easypaisa_status__processing: 'Transaction is being processed',
  easypaisa_status__processing_label: 'Processing...',
  easypaisa_status__success_title: 'Payment Successful',
  easypaisa_status__failed_title: 'Payment failed. Please try again',
  easypaisa_status__payment_details: 'Payment details',
  easypaisa_status__initiation_date: 'Initiation date',
  easypaisa_status__amount: 'Amount',
  easypaisa_status__return: 'RETURN TO WEBSITE',
};
